"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var retry_exports = {};
__export(retry_exports, {
  DEFAULT_RETRY_OPTIONS: () => DEFAULT_RETRY_OPTIONS,
  createRetryableFunction: () => createRetryableFunction,
  withRetry: () => withRetry
});
module.exports = __toCommonJS(retry_exports);
var import_logger = require("./logger");
var import_retryable = require("./retryable");
var import_delay = require("./delay");
const DEFAULT_RETRY_OPTIONS = {
  maxRetries: 5,
  isRetryable: import_retryable.retryNetworkErrors,
  delayStrategy: import_delay.DelayStrategyFactory.exponentialBackoff({
    initialDelayMs: 1e3,
    maxDelayMs: 3e4,
    backoffFactor: 1.5,
    jitter: 0.2
  }),
  logger: import_logger.defaultLogger
};
async function withRetry(operation, options = {}, operationName = "operation") {
  const config = { ...DEFAULT_RETRY_OPTIONS, ...options };
  const logger = config.logger ?? import_logger.defaultLogger;
  let attempt = 1;
  let lastError;
  while (attempt <= config.maxRetries) {
    try {
      return await operation();
    } catch (error) {
      lastError = error;
      const isLastAttempt = attempt >= config.maxRetries;
      if (isLastAttempt) {
        logger.error(`${operationName} failed after ${attempt} attempts`, {
          error,
          attempt,
          maxRetries: config.maxRetries
        });
        throw error;
      }
      if (!config.isRetryable(error)) {
        logger.error(`${operationName} failed with non-retriable error`, {
          error,
          attempt,
          maxRetries: config.maxRetries
        });
        throw error;
      }
      const delayMs = Math.round(config.delayStrategy.getDelay(attempt));
      logger.warn(`${operationName} failed, retrying in ${delayMs}ms`, {
        error,
        attempt,
        nextAttempt: attempt + 1,
        delayMs
      });
      await (0, import_delay.sleep)(delayMs);
      attempt++;
    }
  }
  throw lastError ?? new Error(`${operationName} failed for unknown reason`);
}
__name(withRetry, "withRetry");
function createRetryableFunction(fn, options = {}, operationName = "operation") {
  return (async (...args) => {
    return await withRetry(() => fn(...args), options, operationName);
  });
}
__name(createRetryableFunction, "createRetryableFunction");
//# sourceMappingURL=retry.js.map
